import styled from 'styled-components';

export const Footer = styled.div`
  height: 20%;
  padding: 0 15px;
  position: relative;
  img {
    box-shadow: 0 0 12px #cfcfcf;
    width: 100%;
    height: 95%;
  }
`;

export const Event = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 45%;
  width: 15px;
  height: 15px;
  opacity: 1;
  background-color: #9ca20c;
  border-radius: 50%;

  @media (max-width: 900px) {
    width: 10px;
    height: 10px;
  }

  &:hover {
    ::after {
      opacity: 1;
    }
  }

  ::after {
    opacity: 0;
    transition: opacity 2s;
    font-size: 11px;
    padding-left: 30px;
    content: 'Free parking spaces: 223';
    height: 24px;
    display: block;
    width: 128px;
    line-height: 23px;
    background: #fff;
    border-radius: 50% 6% 6% 50%;
    margin-left: 24px;
  }

  &:nth-child(2) {
    bottom: 25%;
    ::after {
      content: 'Free charging points: 12';
    }
  }
`;
